const customSelectors = {};
class customJS {
    constructor() {
        this._passwordless();
        this._manageDiscountModal();
    }

    /**
     * -------------------- Password less login (update send code message) --------------------
     */
    _passwordless=()=>{
        if (window.location.pathname === "/tools/recurring/get-subscription-access") {
            const urlParams = new URLSearchParams(window.location.search);
            let email = urlParams.get('email');
            if (email) {
              let emailSentMessage = document.querySelector('.rc-enter-code-header')
              if (emailSentMessage) {
                emailSentMessage.innerHTML = '<span>WE SENT A CODE TO <span class="customer-email text-lowercase">' + email + '<span></span>';
              }
            } else {
              const textBox = document.querySelector('[data-rc-email-input]');
              const button = document.querySelector('[data-rc-login-form-submit-btn-animation]');
              if (button) {
                button.addEventListener('click', function() {
                  email = textBox.value;
                  let emailSentMessage = document.querySelector('.rc-enter-code-header')
                  if (emailSentMessage) {
                    emailSentMessage.innerHTML = '<span>WE SENT A CODE TO <span class="customer-email text-lowercase">' + email + '<span></span>';
                  }
                });
              }
            }
        }
    }

    _manageDiscountModal=()=>{
      setTimeout(() => {
        let isDiscountCodeApplied = Utility.getCookie('discount_code');
        let isModalDisplayed = localStorage.getItem('discount_code_modal');
        if (isModalDisplayed != "true" && isDiscountCodeApplied && isDiscountCodeApplied == 'Facebook20') {
          document.querySelector(`#discountcode-notifier`)?.show();
          localStorage.setItem('discount_code_modal',true);
        }
        if (isDiscountCodeApplied == undefined || isDiscountCodeApplied == null) {
          localStorage.removeItem('discount_code_modal');
        }
      }, 100);
    }
}

typeof customJS !== 'undefined' && new customJS();
